// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"Sidebar__Sidebar__IEBl5","Open":"Sidebar__Open__1Nr8m","Close":"Sidebar__Close__1RTyi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidebar/Sidebar.css
// module id = 138
// module chunks = 0